import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { saveState, loadState, removeState } from "../browser-storage/browser-storage";
import IconApp from "../../models/iconApp";

type InitialState = {
    iconApp: IconApp
}
const type = 'iconApp'

const initialState: InitialState = {
    iconApp: loadState(type)
}

export const iconAppSlice = createSlice({
    name: type,
    initialState: initialState,
    reducers: {
        setIconApp: (state, action: PayloadAction<IconApp>) => {
            state.iconApp = action.payload;
            saveState(type, action.payload)
        },
        removeIconApp: (state) => {
            state.iconApp = {};
            removeState(type)
        },
    },
});

// Action creators are generated for each case reducer function
export const { setIconApp, removeIconApp } = iconAppSlice.actions;

export default iconAppSlice.reducer;
